export default class Utils {
    static formatDateToYYYYMMDD(date?: Date | string) {
        if (!date) return;

        const d = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(d.getTime())) return;

        const year = d.getUTCFullYear();
        const month = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    static formatDateToTime(date: Date | string) {
        const d = typeof date === 'string' ? new Date(date) : date;

        if (isNaN(d.getTime())) return;

        const hours = String(d.getUTCHours()).padStart(2, '0');
        const minutes = String(d.getUTCMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    static formatLocalDateToYYYYMMDD(date?: Date | string) {
        if (!date) return;

        const d = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(d.getTime())) return;

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    static formatLocalDateToTime(date?: Date | string) {
        if (!date) return;

        const d = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(d.getTime())) return;

        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    static formatPhoneNumber(value: string): string {
        const digits = value.replace(/\D/g, '');
        if (digits.length === 10)
            return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
        if (digits.length === 11 && digits[0] === '1')
            return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
        return value.trim();
    }

    static formatPhoneNumbers(value: string): string {
        return value.split(';').map((segment) => Utils.formatPhoneNumber(segment)).join('; ');
    }
}
